
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 4h4V0H0v4zm6 12h4v-4H6v4zm-6 0h4v-4H0v4zm0-6h4V6H0v4zm6 0h4V6H6v4zm6-10v4h4V0h-4zM6 4h4V0H6v4zm6 6h4V6h-4v4zm0 6h4v-4h-4v4z"}})])
          )
        }
      }
    